import Moment from 'moment';

/* Funções comuns */

export const isDefined = (variable) => {
    return variable !== 'undefined' && typeof variable !== 'undefined' && variable !== null && (!(variable instanceof Array) || variable.length > 0);
}

export const isEmpty = (str) => {
    return (!str || 0 === str.length);
}

/**
 * Formata uma string para o formato decimal brasileiro.
 * @param {*} numero 
 * @param {int} casasDecimais 
 */
export const decimalFormat = (numero, casasDecimais) => {
    return parseDecimal(numero, casasDecimais).toLocaleString('pt-BR', { minimumFractionDigits: casasDecimais });
}

/**
 * Converte uma string em float.
 * @param {*} numero 
 * @param {int} casasDecimais 
 */
export const parseDecimal = (numero, casasDecimais) => {
    if(!isDefined(numero)){
        numero = '0';
    }

    numero = numero.toString().replace(/\D/g, '');
    
    if(numero.length <= casasDecimais){
        while(numero.length <= casasDecimais){
            numero = '0' + numero;
        }
    }
    
    numero = numero.substring(0, numero.length - casasDecimais) + '.' + numero.substring(numero.length - casasDecimais, numero.length);
    
    return parseFloat(numero);
}

/**
 * Example response:
 * { 
 *      "cep": "80620-100", 
 *      "logradouro": "Rua Santa Catarina", 
 *      "complemento": "até 754/755", 
 *      "bairro": "Água Verde", 
 *      "localidade": "Curitiba", 
 *      "uf": "PR", 
 *      "unidade": "", 
 *      "ibge": "4106902", 
 *      "gia": "" 
 * }
 * @param {string} cep 
 * @param {function} onFinish 
 */
export const buscarCep = (cep, onFinish) => {
    cep = cep.replace(/\D/g, '');

    fetch(`https://viacep.com.br/ws/${cep}/json/`)
        .then(response => response.json())
        .then(onFinish)
        .catch(onFinish)
}

export const mascaraCep = (cep) => {
    if(isDefined(cep)){
        cep = cep.replace(/\D/g, '');

        if(cep.length >= 8){
            cep = cep.substring(0, 5) + '-' + cep.substring(5, 8);
        }
    }
    
    return cep;
}

export const mascaraPlaca = (placa) => {
    if(isDefined(placa)){
        placa = placa.replace(/[^a-z0-9]/gi, '');
        
        if (placa.length > 3){
            placa = placa.substring(0, 3).toUpperCase() + placa.substring(3, (placa.length > 7 ? 7 : placa.length )).replace(/\D/g, '');
            
            if(placa.length === 7){
                placa = placa.substring(0, 3) + '-' + placa.substring(3, 7);
            }
        }else{
            placa = placa.replace(/[^a-z]/gi, '').toUpperCase();
        }
    }
    
    return placa;
}

export const mascaraData = (data, format = 'DDMMYYYY') => {
    data = data.replace(/\D/g, '');
    data = data.substring(0, data.length > 8 ? 8 : data.length);
    
    if(data.length === 8) {
        let moment = Moment(data, format);

        if(moment.isValid()){
            data = moment.format('DD/MM/YYYY');
        }
    }
    
    return data
}

export const validarCPF = (cpf) => {  
    cpf = cpf.replace(/[^\d]+/g,'');    
    
    if(cpf === ''){
        return false; 
    } 
    
    // Elimina CPFs invalidos conhecidos    
    if (cpf.length !== 11 || 
        cpf === "00000000000" || 
        cpf === "11111111111" || 
        cpf === "22222222222" || 
        cpf === "33333333333" || 
        cpf === "44444444444" || 
        cpf === "55555555555" || 
        cpf === "66666666666" || 
        cpf === "77777777777" || 
        cpf === "88888888888" || 
        cpf === "99999999999"){
            
        return false;       
    }

    // Valida 1o digito 
    let add = 0;    
    for (let i = 0; i < 9; i ++){
        add += parseInt(cpf.charAt(i), 10) * (10 - i);  
    }

    let rev = 11 - (add % 11);  
    if (rev === 10 || rev === 11){
        rev = 0;    
    }

    if (rev !== parseInt(cpf.charAt(9), 10)){
        return false;       
    }

    // Valida 2o digito 
    add = 0;    
    for (let i = 0; i < 10; i ++){
        add += parseInt(cpf.charAt(i), 10) * (11 - i);  
    }

    rev = 11 - (add % 11);  
    if (rev === 10 || rev === 11){
        rev = 0;    
    }

    if (rev !== parseInt(cpf.charAt(10), 10)){
        return false;       
    }

    return true;   
}

export const arrayContains = (array, object) => {
    return array.indexOf(object) > -1;
}

export const arrayRemove = (array, object) => {
    const index = array.indexOf(object);

    if(index > -1){
        array.splice(index, 1);
    }

    return array;
}

export const addAlert = (container, titulo = '', mensagem = '', tipo = 'success') => {
    const config = {
        timeOut: 5000,
        extendedTimeOut: 3000,
        closeButton: true
    };

    switch(tipo){
        case 'error':
            container.error(
                mensagem,
                titulo,
                config
            )
            break;
        case 'warning':
            container.warning(
                mensagem,
                titulo,
                config
            )
            break;
        case 'success':
            container.success(
                mensagem,
                titulo,
                config
            )
            break;
        default:
            container.info(
                titulo,
                mensagem,
                config
            )
    }
}
/**
 * Ref.: https://github.com/jeremyBanks/b64-to-blob/
 * @param {*} b64Data - String Base 64
 * @param {*} contentType - Content-type
 * @param {*} sliceSize - Slice-size, default 512 funciona bem na maioria dos casos
 */
export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, {type: contentType});
}

export const downloadFile = (filename, blob) => {
    // window.open("data:application/pdf;base64, " + documento.data)

    var downloadLink = document.createElement('a');
    downloadLink.target = '_blank';
    downloadLink.download = filename;

    var URL = window.URL || window.webkitURL;
    var downloadUrl = URL.createObjectURL(blob);

    downloadLink.href = downloadUrl;
    document.body.appendChild(downloadLink);
    
    downloadLink.click();
    
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(downloadUrl);
}

export const getRandomSemanticColor = () => {
    return semanticColors[Math.floor(Math.random() * semanticColors.length)];
}

/* Arrays/options comuns que serão compartilhadas entre várias telas */

export const situacaoOptions = [
    {
        text: 'Em aberto',
        value: 'A'
    },
    {
        text: 'Baixado',
        value: 'P'
    }
]

export const tipoFreteOptions = [
    {
        text: 'Frete pago',
        value: 'PG'
    },
    {
        text: 'Frete à pagar',
        value: 'AP'
    }
]

export const semanticColors = [
    'red', 
    'orange', 
    'yellow', 
    'olive', 
    'green', 
    'teal',
    'blue', 
    'violet', 
    'purple', 
    'pink', 
    'brown', 
    'grey', 
    'black',
]

export const estadoOptions = [
    {
        text: 'Acre',
        value: 'AC'
    },
    {
        text: 'Alagoas',
        value: 'AL'
    },
    {
        text: 'Amapá',
        value: 'AP'
    },
    {
        text: 'Amazonas',
        value: 'AM'
    },
    {
        text: 'Bahia',
        value: 'BA'
    },
    {
        text: 'Ceará',
        value: 'CE'
    },
    {
        text: 'Distrito Federal',
        value: 'DF'
    },
    {
        text: 'Espírito Santo',
        value: 'ES'
    },
    {
        text: 'Goiás',
        value: 'GO'
    },
    {
        text: 'Maranhão',
        value: 'MA'
    },
    {
        text: 'Mato Grosso',
        value: 'MT'
    },
    {
        text: 'Mato Grosso do Sul',
        value: 'MS'
    },
    {
        text: 'Minas Gerais',
        value: 'MG'
    },
    {
        text: 'Pará',
        value: 'PA'
    },
    {
        text: 'Paraíba',
        value: 'PB'
    },
    {
        text: 'Paraná',
        value: 'PR'
    },
    {
        text: 'Pernambuco',
        value: 'PE'
    },
    {
        text: 'Piauí',
        value: 'PI'
    },
    {
        text: 'Rio de Janeiro',
        value: 'RJ'
    },
    {
        text: 'Rio Grande do Norte',
        value: 'RN'
    },
    {
        text: 'Rio Grande do Sul',
        value: 'RS'
    },
    {
        text: 'Rondônia',
        value: 'RO'
    },
    {
        text: 'Roraima',
        value: 'RR'
    },
    {
        text: 'Santa Catarina',
        value: 'SC'
    },
    {
        text: 'São Paulo',
        value: 'SP'
    },
    {
        text: 'Sergipe',
        value: 'SE'
    },
    {
        text: 'Tocantins',
        value: 'TO'
    }
]


// WEBPACK FOOTER //
// ./src/util/Common.js